import { DateCell, dateTimeFormatter, formatNumber, formattedCell } from '@dec/shared';
import { type ColDef, type ValueFormatterParams } from 'ag-grid-community';
import { headers } from 'app/modules/Taxpayer/TaxpayerTaxReturns/translation';
import { t } from 'i18next';
import { ArrowRight, Search } from 'react-bootstrap-icons';

import { ActionsGrid } from '@/app/components/grid';
import { type ActionColumn } from '@/app/components/grid/actions-column';
import { type TaxReturnSummary } from '@/app/modules/tax-returns/models/TaxReturn';

export const getColumns = (
  includeTin: boolean,
  onView: (payment: TaxReturnSummary) => void,
  onRegister: (payment: TaxReturnSummary) => void
): Array<ColDef> => {
  const actions: Array<ActionColumn> = [
    {
      icon: Search,
      variant: 'secondary',
      onClick: async (row: TaxReturnSummary) => {
        onView(row);
      }
    },
    {
      icon: ArrowRight,
      variant: 'primary',
      onClick: async (row: TaxReturnSummary) => {
        onRegister(row);
      }
    }
  ];

  const colDef: Array<ColDef> = [
    {
      headerName: headers(t, 'actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    ...(includeTin
      ? [
          { headerName: t('config.tinLegend'), field: 'taxpayer.tin' },
          { headerName: t('common.label.name'), field: 'taxpayer.name' }
        ]
      : []),
    { headerName: t('config.taxReturn'), field: 'taxReturnNumber' },
    {
      headerName: headers(t, 'period'),
      field: 'period'
    },
    {
      headerName: t('taxpayer-payments.label.amount'),
      field: 'taxReturnTotal',
      cellStyle: () => {
        return { 'text-align': 'right' };
      },
      valueFormatter: (params: ValueFormatterParams) => {
        return formatNumber(params.value);
      }
    },
    {
      headerName: headers(t, 'createDate'),
      field: 'createdDate',
      ...formattedCell(dateTimeFormatter, DateCell)
    },
    {
      headerName: headers(t, 'taxreturnType'),
      field: 'taxReturnType',
      valueFormatter: (params: ValueFormatterParams) => {
        return t(`common.taxreturn-types.${params.value}`);
      }
    },
    {
      headerName: headers(t, 'taxReturnStatus'),
      field: 'taxReturnStatus',
      valueFormatter: (params: ValueFormatterParams) => {
        return t(`common.taxreturn-status.${params.value}`);
      }
    },
    {
      headerName: headers(t, 'form'),
      field: 'formVersion.form.code'
    },
    {
      headerName: headers(t, 'active'),
      field: 'active',
      valueFormatter: (params: ValueFormatterParams) => {
        return t(`common.yes-no.${params.value ? 'yes' : 'no'}`);
      }
    }
  ];

  return colDef;
};
